import * as Rx from 'rxjs';
import { useEffect, startTransition } from 'react';

var Events;
(function (Events) {
    Events["SEARCH"] = "SEARCH";
    Events["GET_BAG"] = "GET_BAG";
    Events["SHOPPING_BAG_GET"] = "SHOPPING_BAG_GET";
    Events["SHOPPING_BAG_GET_CALLBACK"] = "SHOPPING_BAG_GET_CALLBACK";
    Events["SHOPPING_BAG_GET_STATE_ONLY_CALLBACK"] = "SHOPPING_BAG_GET_STATE_ONLY_CALLBACK";
    Events["SHOPPING_BAG_REMOVE"] = "SHOPPING_BAG_REMOVE";
    Events["SHOPPING_BAG_REMOVE_CALLBACK"] = "SHOPPING_BAG_REMOVE_CALLBACK";
    Events["SHOPPING_BAG_ADD"] = "SHOPPING_BAG_ADD";
    Events["SHOPPING_BAG_ADD_CALLBACK"] = "SHOPPING_BAG_ADD_CALLBACK";
    Events["SHOPPING_BAG_ADD_CIST"] = "SHOPPING_BAG_ADD_CIST";
    Events["SHOPPING_BAG_ADD_CIST_CALLBACK"] = "SHOPPING_BAG_ADD_CIST_CALLBACK";
    Events["SHOPPING_BAG_ADD_MULTIPLE"] = "SHOPPING_BAG_ADD_MULTIPLE";
    Events["SHOPPING_BAG_ADD_MULTIPLE_CALLBACK"] = "SHOPPING_BAG_ADD_MULTIPLE_CALLBACK";
    Events["SHOPPING_BAG_ADD_WARRANTY"] = "SHOPPING_BAG_ADD_WARRANTY";
    Events["SHOPPING_BAG_ADD_WARRANTY_CALLBACK"] = "SHOPPING_BAG_ADD_WARRANTY_CALLBACK";
    Events["SHOPPING_BAG_ADD_LINKED_ITEM"] = "SHOPPING_BAG_ADD_LINKED_ITEM";
    Events["SHOPPING_BAG_ADD_LINKED_ITEM_CALLBACK"] = "SHOPPING_BAG_ADD_LINKED_ITEM_CALLBACK";
    Events["SHOPPING_BAG_UPDATE_SIZE"] = "SHOPPING_BAG_UPDATE_SIZE";
    Events["SHOPPING_BAG_UPDATE_SIZE_CALLBACK"] = "SHOPPING_BAG_UPDATE_SIZE_CALLBACK";
    Events["SHOPPING_BAG_UPDATE_QUANTITY"] = "SHOPPING_BAG_UPDATE_QUANTITY";
    Events["SHOPPING_BAG_UPDATE_QUANTITY_CALLBACK"] = "SHOPPING_BAG_UPDATE_QUANTITY_CALLBACK";
    Events["SHOPPING_BAG_ADD_VOUCHER"] = "SHOPPING_BAG_ADD_VOUCHER";
    Events["SHOPPING_BAG_ADD_VOUCHER_CALLBACK"] = "SHOPPING_BAG_ADD_VOUCHER_CALLBACK";
    Events["SHOPPING_BAG_ADD_EVOUCHER"] = "SHOPPING_BAG_ADD_EVOUCHER";
    Events["SHOPPING_BAG_ADD_EVOUCHER_CALLBACK"] = "SHOPPING_BAG_ADD_EVOUCHER_CALLBACK";
    Events["SHOPPING_BAG_ACCEPT"] = "SHOPPING_BAG_ACCEPT";
    Events["SHOPPING_BAG_ACCEPT_CALLBACK"] = "SHOPPING_BAG_ACCEPT_CALLBACK";
    Events["SHOPPING_BAG_REJECT"] = "SHOPPING_BAG_REJECT";
    Events["SHOPPING_BAG_REJECT_CALLBACK"] = "SHOPPING_BAG_REJECT_CALLBACK";
    Events["SHOPPING_BAG_ADD_SAMPLE"] = "SHOPPING_BAG_ADD_SAMPLE";
    Events["SHOPPING_BAG_ADD_SAMPLE_CALLBACK"] = "SHOPPING_BAG_ADD_SAMPLE_CALLBACK";
    Events["SHOPPING_BAG_REMOVE_SAMPLE"] = "SHOPPING_BAG_REMOVE_SAMPLE";
    Events["SHOPPING_BAG_REMOVE_SAMPLE_CALLBACK"] = "SHOPPING_BAG_REMOVE_SAMPLE_CALLBACK";
    Events["SHOPPING_BAG_ADD_GIFT_CARD"] = "SHOPPING_BAG_ADD_GIFT_CARD";
    Events["SHOPPING_BAG_ADD_GIFT_CARD_CALLBACK"] = "SHOPPING_BAG_ADD_GIFT_CARD_CALLBACK";
    Events["SHOPPING_BAG_ADD_CUSTOM_ITEM"] = "SHOPPING_BAG_ADD_CUSTOM_ITEM";
    Events["SHOPPING_BAG_ADD_CUSTOM_ITEM_CALLBACK"] = "SHOPPING_BAG_ADD_CUSTOM_ITEM_CALLBACK";
    Events["SHOPPING_BAG_ADD_PERSONALISED_ITEM"] = "SHOPPING_BAG_ADD_PERSONALISED_ITEM";
    Events["SHOPPING_BAG_ADD_PERSONALISED_ITEM_CALLBACK"] = "SHOPPING_BAG_ADD_PERSONALISED_ITEM_CALLBACK";
    Events["FAVOURITES_GET"] = "FAVOURITES_GET";
    Events["FAVOURITES_GET_CALLBACK"] = "FAVOURITES_GET_CALLBACK";
    Events["FAVOURITES_ADD"] = "FAVOURITES_ADD";
    Events["FAVOURITES_ADD_CALLBACK"] = "FAVOURITES_ADD_CALLBACK";
    Events["FAVOURITES_REMOVE"] = "FAVOURITES_REMOVE";
    Events["FAVOURITES_REMOVE_CALLBACK"] = "FAVOURITES_REMOVE_CALLBACK";
    Events["VISITOR_TOKEN_GET"] = "VISITOR_TOKEN_GET";
    Events["VISITOR_TOKEN_GET_CALLBACK"] = "VISITOR_TOKEN_GET_CALLBACK";
    Events["VISITOR_TOKEN_UPGRADE"] = "VISITOR_TOKEN_UPGRADE";
    Events["VISITOR_TOKEN_CLEAR"] = "VISITOR_TOKEN_CLEAR";
    Events["VISITOR_TOKEN_CLEAR_CALLBACK"] = "VISITOR_TOKEN_CLEAR_CALLBACK";
    Events["COUNTRY_SELECTOR_OPEN"] = "COUNTRY_SELECTOR_OPEN";
    Events["COUNTRY_SELECTOR_CLOSED"] = "COUNTRY_SELECTOR_CLOSED";
    Events["COUNTRY_SELECTOR_REDIRECT"] = "COUNTRY_SELECTOR_REDIRECT";
    Events["COUNTRY_SELECTOR_REDIRECT_TO_ALTERNATIVE_LANGUAGE"] = "COUNTRY_SELECTOR_REDIRECT_TO_ALTERNATIVE_LANGUAGE";
    Events["PRODUCT_SUMMARY_HYDRATE"] = "PRODUCT_SUMMARY_HYDRATE";
    Events["PRODUCT_SUMMARY_DEBOUNCE_TO_DATALAYER"] = "PRODUCT_SUMMARY_DEBOUNCE_TO_DATALAYER";
    Events["PRODUCT_SUMMARY_TRACK_PAGE"] = "PRODUCT_SUMMARY_TRACK_PAGE";
    Events["PLP_ADD_PRODUCTS_TO_MONETATE"] = "PLP_ADD_PRODUCTS_TO_MONETATE";
    Events["PRODUCT_ADD_PRODUCT_NUMBER"] = "PRODUCT_ADD_PRODUCT_NUMBER";
    Events["SEARCH_LANDING_BLOOMREACH_CATEGORY"] = "SEARCH_LANDING_BLOOMREACH_CATEGORY";
    Events["MODALS_CLOSE"] = "MODALS_CLOSE";
    Events["MASID_UPDATED"] = "MASID_UPDATED";
    Events["TRACK_EVENT"] = "TRACK_EVENT";
    Events["TRACK_EVENT_LAZY"] = "TRACK_EVENT_LAZY";
    Events["TRACK_SITE_DETAILS_EVENT"] = "TRACK_SITE_DETAILS_EVENT";
    Events["PAGE_READY_FOR_GA_EVENTS"] = "PAGE_READY_FOR_GA_EVENTS";
    Events["COOKIE_POLICY_CLOSE"] = "COOKIE_POLICY_CLOSE";
    Events["COOKIE_POLICY_OPEN"] = "COOKIE_POLICY_OPEN";
    Events["COOKIE_POLICY_REDIRECT"] = "COOKIE_POLICY_REDIRECT";
    Events["REQUEST_MASID"] = "REQUEST_MASID";
    Events["ONSITE_COOKIE_CONSENT_VALUE_CHANGED"] = "ONSITE_COOKIE_CONSENT_VALUE_CHANGED";
    Events["SDK_ADD_TO_BAG"] = "SDK_ADD_TO_BAG";
    Events["PERSONALISATION_DATA_RETRIEVED"] = "PERSONALISATION_DATA_RETRIEVED";
})(Events || (Events = {}));
var Events$1 = Events;

var _a;
const hasOwnProp = {}.hasOwnProperty;
if (typeof window !== "undefined") {
    window.subjects = (_a = window.subjects) !== null && _a !== void 0 ? _a : {
        setupEvent: (eventName) => {
            if (!window.subjects[eventName]) {
                window.subjects[eventName] = new Rx.ReplaySubject(1);
            }
        },
    };
}
class Emitter {
    static get Instance() {
        if (!this.instance)
            this.instance = new this();
        return this.instance;
    }
    createName(name) {
        return `$ ${name}`;
    }
    emit(name, data) {
        const fnName = this.createName(name);
        window.subjects[fnName] || (window.subjects[fnName] = new Rx.ReplaySubject(1));
        window.subjects[fnName].next(data);
    }
    listen(name, handler) {
        const fnName = this.createName(name);
        window.subjects[fnName] || (window.subjects[fnName] = new Rx.ReplaySubject(1));
        return window.subjects[fnName].subscribe(handler);
    }
    dispose() {
        const { subjects } = window;
        for (const prop in subjects) {
            if (hasOwnProp.call(subjects, prop)) {
                subjects[prop].dispose();
            }
        }
        window.subjects = {};
    }
}
var Emitter$1 = Emitter.Instance;

class CommonESB {
    constructor() {
        this.subscriptions = {};
    }
    PublishData(event, data) {
        Emitter$1.emit(event, data);
    }
    SubscribeToEvent(event, cb) {
        const subscription = Emitter$1.listen(event, cb);
        if (event in this.subscriptions)
            return {
                subscription: this.subscriptions[event],
            };
        this.subscriptions[event] = subscription;
        return {
            subscription,
        };
    }
    UnsubscribeAll() {
        try {
            Object.keys(this.subscriptions).forEach(key => {
                this.subscriptions[key].unsubscribe();
                delete this.subscriptions[key];
            });
        }
        catch {
            throw new Error("An error occurred unsubscribing from event");
        }
    }
}

class SearchESB extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SEARCH, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SEARCH, callback);
    }
}

class GetFavourites extends CommonESB {
    publish() {
        super.PublishData(Events$1.FAVOURITES_GET);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.FAVOURITES_GET, callback);
    }
}
class GetFavouritesCallback extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.FAVOURITES_GET_CALLBACK, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.FAVOURITES_GET_CALLBACK, callback);
    }
}

class AddFavourites extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.FAVOURITES_ADD, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.FAVOURITES_ADD, callback);
    }
}
class AddMultipleFavourites extends CommonESB {
    publish(data) {
        data.forEach(item => {
            super.PublishData(Events$1.FAVOURITES_ADD, item);
        });
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.FAVOURITES_ADD, callback);
    }
}
class AddFavouritesCallback extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.FAVOURITES_ADD_CALLBACK, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.FAVOURITES_ADD_CALLBACK, callback);
    }
}

class RemoveFavourites extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.FAVOURITES_REMOVE, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.FAVOURITES_REMOVE, callback);
    }
}
class RemoveMultipleFavourites extends CommonESB {
    publish(data) {
        data.forEach(item => {
            super.PublishData(Events$1.FAVOURITES_REMOVE, item);
        });
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.FAVOURITES_REMOVE, callback);
    }
}
class RemoveFavouritesCallback extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.FAVOURITES_REMOVE_CALLBACK, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.FAVOURITES_REMOVE_CALLBACK, callback);
    }
}

class PageLandingESB extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SEARCH_LANDING_BLOOMREACH_CATEGORY, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SEARCH_LANDING_BLOOMREACH_CATEGORY, callback);
    }
}

class GetBag extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_GET, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_GET, callback);
    }
}
class GetBagCallback extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_GET_CALLBACK, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_GET_CALLBACK, callback);
    }
}
class GetBagStateOnlyCallback extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_GET_STATE_ONLY_CALLBACK, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_GET_STATE_ONLY_CALLBACK, callback);
    }
}

class AddBag extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_ADD, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_ADD, callback);
    }
}
class AddBagCallback extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_ADD_CALLBACK, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_ADD_CALLBACK, callback);
    }
}

class AddCistBag extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_ADD_CIST, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_ADD_CIST, callback);
    }
}
class AddCistBagCallback extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_ADD_CIST_CALLBACK, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_ADD_CIST_CALLBACK, callback);
    }
}

class AddEVoucher extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_ADD_EVOUCHER, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_ADD_EVOUCHER, callback);
    }
}
class AddEVoucherCallback extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_ADD_EVOUCHER_CALLBACK, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_ADD_EVOUCHER_CALLBACK, callback);
    }
}

class AddGiftCard extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_ADD_GIFT_CARD, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_ADD_GIFT_CARD, callback);
    }
}
class AddGiftCardCallback extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_ADD_GIFT_CARD_CALLBACK, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_ADD_GIFT_CARD_CALLBACK, callback);
    }
}

class AddLinkedItem extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_ADD_LINKED_ITEM, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_ADD_LINKED_ITEM, callback);
    }
}
class AddLinkedItemCallback extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_ADD_LINKED_ITEM_CALLBACK, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_ADD_LINKED_ITEM_CALLBACK, callback);
    }
}

class AddMultiple extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_ADD_MULTIPLE, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_ADD_MULTIPLE, callback);
    }
}
class AddMultipleCallback extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_ADD_MULTIPLE_CALLBACK, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_ADD_MULTIPLE_CALLBACK, callback);
    }
}

class AddVoucher extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_ADD_VOUCHER, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_ADD_VOUCHER, callback);
    }
}
class AddVoucherCallback extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_ADD_VOUCHER_CALLBACK, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_ADD_VOUCHER_CALLBACK, callback);
    }
}

class AddWarranty extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_ADD_WARRANTY, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_ADD_WARRANTY, callback);
    }
}
class AddWarrantyCallback extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_ADD_WARRANTY_CALLBACK, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_ADD_WARRANTY_CALLBACK, callback);
    }
}

class AddCustomItem extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_ADD_CUSTOM_ITEM, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_ADD_CUSTOM_ITEM, callback);
    }
}
class AddCustomItemCallback extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_ADD_CUSTOM_ITEM_CALLBACK, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_ADD_CUSTOM_ITEM_CALLBACK, callback);
    }
}

class AddPersonalisedItem extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_ADD_PERSONALISED_ITEM, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_ADD_PERSONALISED_ITEM, callback);
    }
}
class AddPersonalisedItemCallback extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_ADD_PERSONALISED_ITEM_CALLBACK, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_ADD_PERSONALISED_ITEM_CALLBACK, callback);
    }
}

class RemoveBag extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_REMOVE, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_REMOVE, callback);
    }
}
class RemoveBagCallback extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_REMOVE_CALLBACK, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_REMOVE_CALLBACK, callback);
    }
}

class UpdateQuantity extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_UPDATE_QUANTITY, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_UPDATE_QUANTITY, callback);
    }
}
class UpdateQuantityCallback extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_UPDATE_QUANTITY_CALLBACK, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_UPDATE_QUANTITY_CALLBACK, callback);
    }
}

class UpdateSize extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_UPDATE_SIZE, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_UPDATE_SIZE, callback);
    }
}
class UpdateSizeCallback extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_UPDATE_SIZE_CALLBACK, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_UPDATE_SIZE_CALLBACK, callback);
    }
}

class AcceptBag extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_ACCEPT, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_ACCEPT, callback);
    }
}
class AcceptBagCallback extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_ACCEPT_CALLBACK, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_ACCEPT_CALLBACK, callback);
    }
}

class RejectBag extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_REJECT, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_REJECT, callback);
    }
}
class RejectBagCallback extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_REJECT_CALLBACK, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_REJECT_CALLBACK, callback);
    }
}

class AddSample extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_ADD_SAMPLE, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_ADD_SAMPLE, callback);
    }
}
class AddSampleCallback extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_ADD_SAMPLE_CALLBACK, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_ADD_SAMPLE_CALLBACK, callback);
    }
}

class RemoveSample extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_REMOVE_SAMPLE, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_REMOVE_SAMPLE, callback);
    }
}
class RemoveSampleCallback extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.SHOPPING_BAG_REMOVE_SAMPLE_CALLBACK, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.SHOPPING_BAG_REMOVE_SAMPLE_CALLBACK, callback);
    }
}

class GetVisitorToken extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.VISITOR_TOKEN_GET, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.VISITOR_TOKEN_GET, callback);
    }
}
class GetVisitorTokenCallback extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.VISITOR_TOKEN_GET_CALLBACK, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.VISITOR_TOKEN_GET_CALLBACK, callback);
    }
}
class ClearVisitorTokenCallback extends CommonESB {
    publish() {
        super.PublishData(Events$1.VISITOR_TOKEN_CLEAR_CALLBACK);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.VISITOR_TOKEN_CLEAR_CALLBACK, callback);
    }
}

class UpgradeVisitorToken extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.VISITOR_TOKEN_UPGRADE, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.VISITOR_TOKEN_UPGRADE, callback);
    }
}

class ClearVisitorToken extends CommonESB {
    publish() {
        super.PublishData(Events$1.VISITOR_TOKEN_CLEAR);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.VISITOR_TOKEN_CLEAR, callback);
    }
}

class CountrySelectorOpenESB extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.COUNTRY_SELECTOR_OPEN, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.COUNTRY_SELECTOR_OPEN, callback);
    }
}

class CountrySelectorClosedESB extends CommonESB {
    publish() {
        super.PublishData(Events$1.COUNTRY_SELECTOR_CLOSED);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.COUNTRY_SELECTOR_CLOSED, callback);
    }
}

class CountrySelectorRedirectESB extends CommonESB {
    publish() {
        super.PublishData(Events$1.COUNTRY_SELECTOR_REDIRECT);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.COUNTRY_SELECTOR_REDIRECT, callback);
    }
}

class CountrySelectorRedirectToAlternativeLanguageESB extends CommonESB {
    publish() {
        super.PublishData(Events$1.COUNTRY_SELECTOR_REDIRECT_TO_ALTERNATIVE_LANGUAGE);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.COUNTRY_SELECTOR_REDIRECT_TO_ALTERNATIVE_LANGUAGE, callback);
    }
}

class AddProductNumber extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.PRODUCT_ADD_PRODUCT_NUMBER, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.PRODUCT_ADD_PRODUCT_NUMBER, callback);
    }
}

class IntelRecQuickAddToBag {
    static subscribe(callback) {
        const eventHandler = (event) => {
            if (event instanceof CustomEvent && event.detail) {
                callback(event.detail);
            }
        };
        document.addEventListener("Events.SDK_ADD_TO_BAG", eventHandler);
        return {
            unsubscribe: () => {
                document.removeEventListener("Events.SDK_ADD_TO_BAG", eventHandler);
            },
        };
    }
}
const quickAddToBagESB = new IntelRecQuickAddToBag();

class HydrateProductSummaryESB extends CommonESB {
    publish() {
        super.PublishData(Events$1.PRODUCT_SUMMARY_HYDRATE);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.PRODUCT_SUMMARY_HYDRATE, callback);
    }
}

class ProductSummaryToDataLayer extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.PRODUCT_SUMMARY_DEBOUNCE_TO_DATALAYER, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.PRODUCT_SUMMARY_DEBOUNCE_TO_DATALAYER, callback);
    }
}

class ProductSummaryTrackPage extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.PRODUCT_SUMMARY_TRACK_PAGE, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.PRODUCT_SUMMARY_TRACK_PAGE, callback);
    }
}

class AddProductsToMonetate extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.PLP_ADD_PRODUCTS_TO_MONETATE, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.PLP_ADD_PRODUCTS_TO_MONETATE, callback);
    }
}

class ModalsCloseESB extends CommonESB {
    publish() {
        super.PublishData(Events$1.MODALS_CLOSE);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.MODALS_CLOSE, callback);
    }
}

class MasIdUpdated extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.MASID_UPDATED, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.MASID_UPDATED, callback);
    }
}

class TrackEvent extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.TRACK_EVENT, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.TRACK_EVENT, callback);
    }
}

class TrackEventLazy extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.TRACK_EVENT_LAZY, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.TRACK_EVENT_LAZY, callback);
    }
}

class TrackSiteDetailsEvent extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.TRACK_SITE_DETAILS_EVENT, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.TRACK_SITE_DETAILS_EVENT, callback);
    }
}

class PageReadyForGAEvents extends CommonESB {
    publish() {
        super.PublishData(Events$1.PAGE_READY_FOR_GA_EVENTS);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.PAGE_READY_FOR_GA_EVENTS, callback);
    }
}

class CookiePolicyCloseESB extends CommonESB {
    publish() {
        super.PublishData(Events$1.COOKIE_POLICY_CLOSE);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.COOKIE_POLICY_CLOSE, callback);
    }
}

class CookiePolicyOpenESB extends CommonESB {
    publish() {
        super.PublishData(Events$1.COOKIE_POLICY_OPEN);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.COOKIE_POLICY_OPEN, callback);
    }
}

class CookiePolicyRedirectESB extends CommonESB {
    publish() {
        super.PublishData(Events$1.COOKIE_POLICY_REDIRECT);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.COOKIE_POLICY_REDIRECT, callback);
    }
}

class RequestMasId extends CommonESB {
    publish() {
        super.PublishData(Events$1.REQUEST_MASID);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.REQUEST_MASID, callback);
    }
}

class CookieConsentValueChangedESB extends CommonESB {
    publish(data) {
        super.PublishData(Events$1.ONSITE_COOKIE_CONSENT_VALUE_CHANGED, data);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.ONSITE_COOKIE_CONSENT_VALUE_CHANGED, callback);
    }
}

class PersonalisationDataRetrievedESB extends CommonESB {
    publish() {
        super.PublishData(Events$1.PERSONALISATION_DATA_RETRIEVED);
    }
    subscribe(callback) {
        return super.SubscribeToEvent(Events$1.PERSONALISATION_DATA_RETRIEVED, callback);
    }
}

const useCommonObservable = (esb, callback) => {
    return useEffect(() => {
        const transitionedCallback = (data) => {
            callback(data);
        };
        const { subscription } = esb.subscribe(transitionedCallback);
        return () => {
            subscription.unsubscribe();
        };
    }, []);
};

const useSearchObservable = (callback) => {
    return useCommonObservable(new SearchESB(), data => requestIdleCallback(() => callback(data)));
};

const useFavouritesGetCallbackObservable = (callback) => {
    return useCommonObservable(new GetFavouritesCallback(), data => requestIdleCallback(() => callback(data)));
};
const useFavouritesAddCallbackObservable = (callback) => {
    return useCommonObservable(new AddFavouritesCallback(), data => requestIdleCallback(() => callback(data)));
};
const useFavouritesRemoveCallbackObservable = (callback) => {
    return useCommonObservable(new RemoveFavouritesCallback(), data => requestIdleCallback(() => callback(data)));
};

const useShoppingBagGetCallbackObservable = (callback) => {
    return useCommonObservable(new GetBagCallback(), data => requestIdleCallback(() => callback(data)));
};
const useShoppingBagAddCallbackObservable = (callback) => {
    return useCommonObservable(new AddBagCallback(), data => requestIdleCallback(() => callback(data)));
};
const useShoppingBagAddCistCallbackObservable = (callback) => {
    return useCommonObservable(new AddCistBagCallback(), data => requestIdleCallback(() => callback(data)));
};
const useShoppingBagAddEVoucherCallbackObservable = (callback) => {
    return useCommonObservable(new AddEVoucherCallback(), data => requestIdleCallback(() => callback(data)));
};
const useShoppingBagAddLinkedItemCallbackObservable = (callback) => {
    return useCommonObservable(new AddLinkedItemCallback(), data => requestIdleCallback(() => callback(data)));
};
const useShoppingBagAddMultipleCallbackObservable = (callback) => {
    return useCommonObservable(new AddMultipleCallback(), data => requestIdleCallback(() => callback(data)));
};
const useShoppingBagAddWarrantyCallbackObservable = (callback) => {
    return useCommonObservable(new AddWarrantyCallback(), data => requestIdleCallback(() => callback(data)));
};
const useShoppingBagAddCustomItemCallbackObservable = (callback) => {
    return useCommonObservable(new AddCustomItemCallback(), data => requestIdleCallback(() => callback(data)));
};
const useShoppingBagRemoveCallbackObservable = (callback) => {
    return useCommonObservable(new RemoveBagCallback(), data => requestIdleCallback(() => callback(data)));
};
const useShoppingBagUpdateSizeCallbackObservable = (callback) => {
    return useCommonObservable(new UpdateSizeCallback(), data => requestIdleCallback(() => callback(data)));
};
const useShoppingBagUpdateQuantityCallbackObservable = (callback) => {
    return useCommonObservable(new UpdateQuantityCallback(), data => requestIdleCallback(() => callback(data)));
};
const useShoppingBagAcceptCallbackObservable = (callback) => {
    return useCommonObservable(new AcceptBagCallback(), data => requestIdleCallback(() => callback(data)));
};
const useShoppingBagRejectCallbackObservable = (callback) => {
    return useCommonObservable(new RejectBagCallback(), data => requestIdleCallback(() => callback(data)));
};
const useShoppingBagAddSampleCallbackObservable = (callback) => {
    return useCommonObservable(new AddSampleCallback(), data => requestIdleCallback(() => callback(data)));
};
const useShoppingBagRemoveSampleCallbackObservable = (callback) => {
    return useCommonObservable(new RemoveSampleCallback(), data => requestIdleCallback(() => callback(data)));
};
const useShoppingBagAddGiftCardCallbackObservable = (callback) => {
    return useCommonObservable(new AddGiftCardCallback(), data => requestIdleCallback(() => callback(data)));
};
const useShoppingBagAddPersonalisedCallbackObservable = (callback) => {
    return useCommonObservable(new AddPersonalisedItemCallback(), data => requestIdleCallback(() => callback(data)));
};

const useCountrySelectorOpenObservable = (callback) => {
    return useCommonObservable(new CountrySelectorOpenESB(), data => requestIdleCallback(() => callback(data)));
};
const useCountrySelectorRedirectToAlternativeLanguageObservable = (callback) => {
    return useCommonObservable(new CountrySelectorRedirectToAlternativeLanguageESB(), () => requestIdleCallback(() => callback()));
};

const useGetVisitorTokenCallbackObservable = (callback) => {
    return useCommonObservable(new GetVisitorTokenCallback(), data => requestIdleCallback(() => callback(data)));
};
const useClearVisitorTokenCallbackObservable = (callback) => {
    return useCommonObservable(new ClearVisitorTokenCallback(), () => requestIdleCallback(() => callback()));
};

const useProductSummaryHydrateObservable = (callback) => {
    return useCommonObservable(new HydrateProductSummaryESB(), callback);
};

const useModalsCloseObservable = (callback) => {
    return useCommonObservable(new ModalsCloseESB(), () => startTransition(() => callback()));
};

const useMasIdUpdatedObservable = (callback) => {
    return useCommonObservable(new MasIdUpdated(), data => requestIdleCallback(() => callback(data)));
};

const useCookieConsentValueChangedObservable = (callback) => {
    return useCommonObservable(new CookieConsentValueChangedESB(), data => requestIdleCallback(() => callback(data)));
};

const usePersonalisationDataRetrievedObservable = (callback) => {
    return useCommonObservable(new PersonalisationDataRetrievedESB(), callback);
};

export { AcceptBag, AcceptBagCallback, AddBag, AddBagCallback, AddCistBag, AddCistBagCallback, AddCustomItem, AddCustomItemCallback, AddEVoucher, AddEVoucherCallback, AddFavourites, AddFavouritesCallback, AddGiftCard, AddGiftCardCallback, AddLinkedItem, AddLinkedItemCallback, AddMultiple, AddMultipleCallback, AddMultipleFavourites, AddPersonalisedItem, AddPersonalisedItemCallback, AddProductNumber, AddProductsToMonetate, AddSample, AddSampleCallback, AddVoucher, AddVoucherCallback, AddWarranty, AddWarrantyCallback, ClearVisitorToken, ClearVisitorTokenCallback, CookieConsentValueChangedESB, CookiePolicyCloseESB, CookiePolicyOpenESB, CookiePolicyRedirectESB, CountrySelectorClosedESB, CountrySelectorOpenESB, CountrySelectorRedirectESB, CountrySelectorRedirectToAlternativeLanguageESB, Events$1 as Events, GetBag, GetBagCallback, GetBagStateOnlyCallback, GetFavourites, GetFavouritesCallback, GetVisitorToken, GetVisitorTokenCallback, HydrateProductSummaryESB, IntelRecQuickAddToBag, MasIdUpdated, ModalsCloseESB, PageLandingESB, PageReadyForGAEvents, PersonalisationDataRetrievedESB, ProductSummaryToDataLayer, ProductSummaryTrackPage, RejectBag, RejectBagCallback, RemoveBag, RemoveBagCallback, RemoveFavourites, RemoveFavouritesCallback, RemoveMultipleFavourites, RemoveSample, RemoveSampleCallback, RequestMasId, SearchESB, TrackEvent, TrackEventLazy, TrackSiteDetailsEvent, UpdateQuantity, UpdateQuantityCallback, UpdateSize, UpdateSizeCallback, UpgradeVisitorToken, quickAddToBagESB, useClearVisitorTokenCallbackObservable, useCookieConsentValueChangedObservable, useCountrySelectorOpenObservable, useCountrySelectorRedirectToAlternativeLanguageObservable, useFavouritesAddCallbackObservable, useFavouritesGetCallbackObservable, useFavouritesRemoveCallbackObservable, useGetVisitorTokenCallbackObservable, useMasIdUpdatedObservable, useModalsCloseObservable, usePersonalisationDataRetrievedObservable, useProductSummaryHydrateObservable, useSearchObservable, useShoppingBagAcceptCallbackObservable, useShoppingBagAddCallbackObservable, useShoppingBagAddCistCallbackObservable, useShoppingBagAddCustomItemCallbackObservable, useShoppingBagAddEVoucherCallbackObservable, useShoppingBagAddGiftCardCallbackObservable, useShoppingBagAddLinkedItemCallbackObservable, useShoppingBagAddMultipleCallbackObservable, useShoppingBagAddPersonalisedCallbackObservable, useShoppingBagAddSampleCallbackObservable, useShoppingBagAddWarrantyCallbackObservable, useShoppingBagGetCallbackObservable, useShoppingBagRejectCallbackObservable, useShoppingBagRemoveCallbackObservable, useShoppingBagRemoveSampleCallbackObservable, useShoppingBagUpdateQuantityCallbackObservable, useShoppingBagUpdateSizeCallbackObservable };
